<style lang="less" scoped>
  .content {
    width: 100%;
  }
  .result-layout {
    width: 100%;
    text-align: center;
  }
  .table-container {
    width: 100%;
    height: 340px;
  }
  .table {
    width: 100%;
    height: 100%;
    text-align: left;
    font-size: 0;
  }
  .table-col {
    height: 88px;
    width: 16.66%;
    border: 1px solid white;
    display: inline-block;
  }
  .match-number-container {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .match-number {
    height: 100%;
    flex: 1;
  }
  .arrow-row {
    padding: 16px 0;
  }
</style>

<template lang="pug">
  .std-layout
    .header
      header-component(@click-stop='redirectBack')
    .content
      .result-layout
        .up-arrow.arrow-row
          up-arrow-component(
            @click.native='prevPage'
            v-if='page > 0')
        .table-container
          .table
            .table-col(v-for='(data, key) in display')
              .match-number-container
                match-number-component.match-number(
                  v-for='(answer, key) in data.answer'
                  :answer='answer'
                  :input='data["input"][key]'
                  :width='numberFontSize')
        .down-arrow.arrow-row
          down-arrow-component(
            @click.native='nextPage'
            v-if='page < groupCount - 1')
    .footer
      button-component(
        :text='"결과보기"'
        @click='done')
</template>

<script>
import HeaderComponent from '@/components/header/stop';
import MatchNumberComponent from '@/components/match_number_slot';
import ButtonComponent from '@/components/button';
import UpArrowComponent from '@/components/up_arrow';
import DownArrowComponent from '@/components/down_arrow';

import GameType from '@/game';

export default {
  data() {
    return {
      page: 0,
    };
  },
  computed: {
    localStorageKey() {
      const arr = [GameType.mode.training, GameType.game.number, this.time];
      return arr.join('.');
    },
    numberFontSize() {
      let fs = 20;
      switch (this.units) {
        case 3:
          fs = 14;
          break;
        case 2:
          fs = 16;
          break;
        case 1:
          fs = 20;
          break;
        default:
      }
      return fs;
    },
    units() {
      return this.$store.state.app.units;
    },
    answer() {
      return this.$store.state.app.answer;
    },
    input() {
      return this.$store.state.app.input;
    },
    display() {
      const data = [];
      const start = this.page * 24;
      const end = start + 24;
      for (let i = start; i < end; i += 1) {
        const answer = this.answer[i];
        const input = this.input[i] || [];
        if (!answer) {
          break;
        }
        data.push({ answer, input });
      }
      return data;
    },
    groupCount() {
      const count = Math.ceil(this.answer.length / 24);
      return count;
    },
    score() {
      let score = 0;
      // const rows = Math.ceil(this.answer.length / 6);
      // for (let i = 0; i < rows; i += 1) {
      //   let wrong = 0; // 한 줄에서 틀린 갯수
      //   let total = 0; // 한 줄에서 얻을 수 있는 최대 점수
      //   const start = i * 6;
      //   for (let j = start; j < start + 6; j += 1) {
      //     if (!this.answer[j]) {
      //       break;
      //     }
      //     for (let k = 0; k < this.answer[j].length; k += 1) {
      //       const answer = this.answer[j][k];
      //       const input = this.input[j][k];
      //       if (answer !== input) {
      //         wrong += 1;
      //       }
      //       total += 1;
      //     }
      //   }
      //   if (wrong === 1) {
      //     total /= 2;
      //   } else if (wrong >= 2) {
      //     total = 0;
      //   }
      //   score += total;
      // }
      for (let i = 0; i < this.answer.length; i += 1) {
        const answerColumn = this.answer[i];
        const inputColumn = this.input[i];
        for (let j = 0; j < answerColumn.length; j += 1) {
          const answer = answerColumn[j];
          const input = inputColumn[j];
          if (answer && input) {
            if (answer === input) {
              score += 1;
            }
          } else {
            break;
          }
        }
      }
      return score;
    },
    time() {
      return this.$store.state.app.time;
    },
  },
  methods: {
    addBestScore(time, score) {
      const data = JSON.stringify({ time, score });
      this.$localStorage.set(this.localStorageKey, data);
    },
    loadBestScore() {
      const data = JSON.parse(this.$localStorage.get(this.localStorageKey));
      return this.$localStorage.get(this.localStorageKey) ? data : { score: 0, time: 0 };
    },
    done() {
      this.$store.commit('setScore', this.score);
      this.$router.replace('/result');
    },
    prevPage() {
      if (this.page > 0) {
        this.page -= 1;
      }
    },
    nextPage() {
      if (this.page + 1 < this.groupCount) {
        this.page += 1;
      }
    },
    redirectBack() {
      this.$router.go(-1);
    },
    setBestRecord() {
      const record = this.loadBestScore();
      const score = record.score || 0;
      if (score < this.score) {
        this.addBestScore(this.time * 60, this.score);
      }
    },
    addStoreBestScore() {
      const data = this.loadBestScore();
      this.$store.commit('setBestScore', data.score);
    },
    addStoreBestTime() {
      const data = this.loadBestScore();
      this.$store.commit('setBestTime', data.time);
    },
  },
  mounted() {
    this.setBestRecord();
    this.addStoreBestScore();
    this.addStoreBestTime();
  },
  components: {
    HeaderComponent,
    MatchNumberComponent,
    ButtonComponent,
    UpArrowComponent,
    DownArrowComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/number/result.vue